export default __webpack_public_path__ + "static/media/germany-flag.36ea3a31.jpg";